<template>
  <div>
    <section v-if="section.sectionPosition === '1' || section.sectionImage == false " class="text-banner-dark text-banner-layout-small text-center" v-bind:id=" section.sectionFrontId "> 
      <div class="divider-shape"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <h2 class="banner-title">{{ section.section }} </h2>
          </div>
        </div>
      </div>
    </section>
    <section v-else class="text-banner text-banner-layout text-center bg-overlay bg-overlay-gradient bg-parallax" v-bind:style="{ backgroundImage: 'url(' + section.sectionImage + ')' }" v-bind:id=" section.sectionFrontId ">
      <div class="divider-shape"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <h2 class="banner-title">{{ section.section }} </h2>
          </div>
        </div>
      </div>
    </section>
    <section class="menu-layout1 pb-40">
      <div class="container">
          <div class="row">
            <SectionContent v-bind:item="item" v-for = "(item, index) in section.items" v-bind:key="index"></SectionContent>
          </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionContent from './SectionContent';

export default {
  name: 'DisplayMenu',
  props: ['section'],
  components: {
    SectionContent,
  },
}
</script>


<style>
.text-banner-layout {
  padding-top: 150px;
  padding-bottom: 150px;
  background-repeat: no-repeat;
}
.text-banner-layout-small {
  padding-top: 50px;
  padding-bottom: 0px;
}
.text-banner .banner-title {
  font-family: "Yeseva One";
  color: #ffffff;
  font-size: 55px;
  font-weight: 500;
  margin-bottom: 0;
}

.text-banner-dark .banner-title  {
  font-family: "Yeseva One";
  font-size: 55px;
  font-weight: 500;
  margin-bottom: 0;
}
</style>